import { useReadScrolly } from "components/scrolly";
import React from "react";
import { defineMessage, useIntl } from "react-intl";
import { LineChart } from "../charts/LineChart";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_finance_aid_fig_SECTOR_ALLOCABLE";
import { datasets } from "../data/data_finance_aid_fig_SECTOR_ALLOCABLE_datasets";
import { mkGemDataDecoder } from "../domain";
import { useMedia } from "../hooks";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { io, O, pipe } from "../prelude";
export * from "../data/data_finance_aid_fig_SECTOR_ALLOCABLE";
const Sector = io.keyof({
    Education: null,
    Health: null,
    Energy: null,
    Governance: null
});
const sectorLookup = {
    Education: defineMessage({
        id: "fig.finance.aid.SECTOR_ALLOCABLE.education",
        defaultMessage: "Education"
    }),
    Health: defineMessage({
        id: "fig.finance.aid.SECTOR_ALLOCABLE.health",
        defaultMessage: "Health"
    }),
    Governance: defineMessage({
        id: "fig.finance.aid.SECTOR_ALLOCABLE.governance",
        defaultMessage: "Governance"
    }),
    Energy: defineMessage({
        id: "fig.finance.aid.SECTOR_ALLOCABLE.energy",
        defaultMessage: "Energy"
    })
};
const sectorDescriptionLookup = {
    Education: defineMessage({
        id: "fig.finance.AID_LICS.education_detail",
        defaultMessage: "Education"
    }),
    Health: defineMessage({
        id: "fig.finance.AID_LICS.health_detail",
        defaultMessage: "Health"
    }),
    Governance: defineMessage({
        id: "fig.finance.AID_LICS.governance_detail",
        defaultMessage: "Governance"
    }),
    Energy: defineMessage({
        id: "fig.finance.AID_LICS.energy_detail",
        defaultMessage: "Energy"
    })
};
export const Data = mkGemDataDecoder([
    "value",
    "ind_id",
    "year"
], {
    sector: Sector
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenMDown = !useMedia(breakpoints.m);
    const { activeSection } = useReadScrolly();
    const scrollySector = pipe(activeSection, O.getOrElse(()=>""));
    const entityData = React.useMemo(()=>data.map((x)=>({
                ...x,
                sector: intl.formatMessage(sectorLookup[x.sector]),
                sector_description: intl.formatMessage(sectorDescriptionLookup[x.sector])
            })), [
        intl,
        data
    ]);
    return <LineChart tLabel={(s)=>s} height={screenMDown ? M.chartHeight.s : M.chartHeight.m} x="year" yTicks={[
        0,
        0.1,
        0.2,
        0.3
    ]} timeParse="%Y" timeFormat="%Y" numberFormat=".1%" category="datum.sector_description" tooltipFormatX={(x)=>x.sector} colorLegend values={entityData} showTooltip isFaded={(x)=>scrollySector !== "" && x.sector !== scrollySector}/>;
};
export default withFigureIO({
    url: new URL("../data/data_finance_aid_fig_SECTOR_ALLOCABLE.json", import.meta.url).href,
    csv: new URL("../data/data_finance_aid_fig_SECTOR_ALLOCABLE.zip", import.meta.url).href,
    xlsx: new URL("../data/data_finance_aid_fig_SECTOR_ALLOCABLE.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    size: "main",
    datasets
});
